import React from 'react';

const SvgUsaSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 16"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-Flags-UsaSmall__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-Flags-UsaSmall__linearGradient-3",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F0"
})), /*#__PURE__*/React.createElement("rect", {
  id: "tourlane-Flags-UsaSmall__path-1",
  width: 24,
  height: 16,
  x: 0,
  y: 0,
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Flags-UsaSmall__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Flags-UsaSmall__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#tourlane-Flags-UsaSmall__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D02F44",
  fillRule: "nonzero",
  d: "M0 0h24v1.067H0V0zm0 2.133h24V3.2H0V2.133zm0 2.134h24v1.066H0V4.267zM0 6.4h24v1.067H0V6.4zm0 2.133h24V9.6H0V8.533zm0 2.134h24v1.066H0v-1.066zM0 12.8h24v1.067H0V12.8zm0 2.133h24V16H0v-1.067z",
  mask: "url(#tourlane-Flags-UsaSmall__mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#46467F",
  d: "M2 0h7.857v7.467H0V2a2 2 0 012-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#tourlane-Flags-UsaSmall__linearGradient-3)",
  d: "M1.643 2.133a.54.54 0 01-.548-.533.54.54 0 01.548-.533.54.54 0 01.547.533.54.54 0 01-.547.533zm2.19 0a.54.54 0 01-.547-.533.54.54 0 01.547-.533.54.54 0 01.548.533.54.54 0 01-.548.533zm2.19 0a.54.54 0 01-.547-.533.54.54 0 01.548-.533.54.54 0 01.547.533.54.54 0 01-.547.533zm2.191 0a.54.54 0 01-.547-.533.54.54 0 01.547-.533.54.54 0 01.548.533.54.54 0 01-.548.533zM2.738 3.2a.54.54 0 01-.548-.533.54.54 0 01.548-.534.54.54 0 01.548.534.54.54 0 01-.548.533zm2.19 0a.54.54 0 01-.547-.533.54.54 0 01.548-.534.54.54 0 01.547.534.54.54 0 01-.547.533zm2.191 0a.54.54 0 01-.548-.533.54.54 0 01.548-.534.54.54 0 01.548.534.54.54 0 01-.548.533zm1.095 1.067a.54.54 0 01-.547-.534.54.54 0 01.547-.533.54.54 0 01.548.533.54.54 0 01-.548.534zm-2.19 0a.54.54 0 01-.548-.534.54.54 0 01.548-.533.54.54 0 01.547.533.54.54 0 01-.547.534zm-2.19 0a.54.54 0 01-.548-.534.54.54 0 01.547-.533.54.54 0 01.548.533.54.54 0 01-.548.534zm-2.191 0a.54.54 0 01-.548-.534.54.54 0 01.548-.533.54.54 0 01.547.533.54.54 0 01-.547.534zm1.095 1.066A.54.54 0 012.19 4.8a.54.54 0 01.548-.533.54.54 0 01.548.533.54.54 0 01-.548.533zm2.19 0a.54.54 0 01-.547-.533.54.54 0 01.548-.533.54.54 0 01.547.533.54.54 0 01-.547.533zm2.191 0a.54.54 0 01-.548-.533.54.54 0 01.548-.533.54.54 0 01.548.533.54.54 0 01-.548.533zM8.214 6.4a.54.54 0 01-.547-.533.54.54 0 01.547-.534.54.54 0 01.548.534.54.54 0 01-.548.533zm-2.19 0a.54.54 0 01-.548-.533.54.54 0 01.548-.534.54.54 0 01.547.534.54.54 0 01-.547.533zm-2.19 0a.54.54 0 01-.548-.533.54.54 0 01.547-.534.54.54 0 01.548.534.54.54 0 01-.548.533zm-2.191 0a.54.54 0 01-.548-.533.54.54 0 01.548-.534.54.54 0 01.547.534.54.54 0 01-.547.533z"
}))));

export default SvgUsaSmall;